import { Grid, Typography } from "@mui/material";

import CoinSelectItem from "pages/Wallet/Component/FilterMarginHistory/Component/CoinSelectItem";
import DatePicker from "components/DatePicker";
import Select from "components/Select";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function WithdrawOrDepositHistoryFilter() {
  const historyForm = useSelector((state) => state.wallet.historyForm?.data);
  const [searchParams, setSearchParams] = useSearchParams();

  const coinId = +searchParams.get("coinId") || -1;
  const sideId = +searchParams.get("sideId") || 0;
  const startDate = searchParams.get("startDate") || "";
  const endDate = searchParams.get("endDate") || "";

  const defaultValues = {
    coinId,
    sideId,
    endDate,
    startDate,
  };

  const { watch, setValue, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset((formValues) => ({
      ...formValues,
      sideId,
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sideId]);

  const handleChange = (value, fieldName) => {
    setValue(fieldName, value);
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: 1,
      [fieldName]: value,
    });
  };

  return (
    <Grid container spacing={1} my={{ md: 2, xs: 1 }}>
      <Grid item xs={6} md={4}>
        <Typography color="text.main" variant="label">
          From Date
        </Typography>

        <DatePicker
          value={watch("startDate")}
          onChange={(e) => {
            handleChange(e, "startDate");
          }}
        />
      </Grid>

      <Grid item xs={6} md={4}>
        <Typography color="text.main" variant="label">
          To Date
        </Typography>

        <DatePicker
          value={watch("endDate")}
          onChange={(e) => {
            handleChange(e, "endDate");
          }}
        />
      </Grid>

      {historyForm?.lisCoin && (
        <Grid item xs={12} md={4}>
          <Typography color="text.main" variant="label">
            Coin
          </Typography>

          <Select
            customValue={(data) => <CoinSelectItem data={data} />}
            itemText="name"
            itemValue="id"
            value={watch("coinId")}
            items={historyForm?.lisCoin}
            dir="ltr"
            onChange={(e) => {
              handleChange(e.target.value, "coinId");
            }}
          />
        </Grid>
      )}

      <Grid item xs={12} md={4}>
        <Typography color="text.main" variant="label">
          Side
        </Typography>

        <Select
          value={watch("sideId")}
          onChange={(e) => handleChange(e.target.value, "sideId")}
          itemText="name"
          itemValue="id"
          items={historyForm?.lisSide}
          dir="ltr"
        />
      </Grid>
    </Grid>
  );
}

export default WithdrawOrDepositHistoryFilter;
